module.exports = __webpack_public_path__ + "static/media/Kayabaca Logo Full - Green_Vector (1).95d5aa36.png";